module.exports = __webpack_public_path__ + "static/img/nom.8857ae1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/myprize/nom.png
// module id = w4HX
// module chunks = 1